import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { CheckboxWithLabel } from '../Inputs/CheckboxWithLabel';

export type AppointmentSmsOptInCheckboxProps = {
  body?: React.ReactNode;
  className?: string;
};

export const AppointmentSmsOptInCheckbox: React.VFC<AppointmentSmsOptInCheckboxProps> = ({ body, className }) => {
  const { classes, cx } = useStyles();
  const l10n = useL10n();

  return (
    <CheckboxWithLabel
      name="appointmentSmsOptIn"
      color="secondary"
      className={cx(classes.root, className)}
      label={(
        <>
          <Typography variant="body2" color="textPrimary" fontWeight={600} gutterBottom={!!body}>
            {l10n.phoneValidationModal.textAlertDisclosure.appointmentSmsOptIn.label}
          </Typography>
          {body}
        </>
      )}
    />
  );
};

const useStyles = makeStyles({ name: 'AppointmentSmsOptInCheckbox' })(() => ({
  root: {
    alignItems: 'flex-start',
    marginLeft: 0,
  },
}));
